<template>
  <div id="index">
    <el-row class="tac">
      <el-col :span="24" class="Box">
        <div style="display: flex; justify-content: space-between">
          <el-menu
            :default-active="$route.path | getRouterActive"
            class="el-menu-demo"
            text-color="#333"
            @select="SelectMenu"
            :router="true"
          >
            <el-menu-item
              v-for="(item, index) in targetRoutes"
              :key="index"
              :index="item.path"
              >{{ item.meta.title }}</el-menu-item
            >
          </el-menu>

        </div>
        <!-- <Table :list="list" :loading="loading"/> -->
        <router-view></router-view>
      </el-col>
    </el-row>

  </div>
</template>

<script>
// import { mapActions } from "vuex";
// import Table from "../../components/case/List/Table.vue";
export default {
  name: "archive",
  // components:{
  //   Table
  // },
  data() {
    return {
      list: [],
      loading: false,
    };
  },
  created() {},
  methods: {
    enter() {
      this.dialogVisible = true;
      console.log("11111");
    },
    handleClose() {
      this.dialogVisible = false;
    },
    callOf() {
      this.dialogVisible = false;
    },
    confirm() {
      console.log(22222);
    },
    // 关闭dialog时清空表单
    closeForm(formName) {
      this.enterForm = {};
      this.$refs[formName].resetFields();
    },
    SelectMenu(item) {
      let that = this;
      that.$router.push({
        path: `${item}`,
      });
    },
    uploadSuccess(){},
    handleExceed(){},
    handleRemove(){},
  },
  filters: {
    getRouterActive(path) {
      let str = path.split("/");
      return str[3];
    },
  },
  computed: {
    targetRoutes() {
      let target = this.$store.state.permission.addRoutes.filter(
        (el) => el.path == "/home/archive" //遍历每一个数组，过滤出返回值委true的值
      );
      return target[0].children;
    },
  },
};
</script>
<style lang="less" scoped>
#index {
  .tac {
    .el-menu {
      display: flex;
      height: 55px;
      text-align: center;
      border-right: 0px;
      // margin-bottom: 5vh;
      // .el-menu-item{
      //   width:20vh;
      // }
      .el-menu-item {
        margin: 0 20px;
        height: 100%;
        display: flex;
        align-items: center;
        min-width: 30px;
        width: 10vh;
        justify-content: center;
        &:hover {
          background-color: #fff;
          color: #409eff !important;
          border-bottom: 1px solid #409eff;
        }
      }
      .el-menu-item.is-active {
        background-color: #fff !important;
        border-bottom: 1px solid #409eff;
      }
    }
    .enterbutton {
      width: 99px;
      height: 40px;
      margin: 10px;
      color: #fff;
      background-color: #2bc887;
      line-height: 40px;
      text-align: center;
      border-radius: 4px;
      cursor: pointer;
    }
  }
  .Box {
    // padding: 20px 30px;
    box-sizing: border-box;
    background: #fff;
    // background: #409eff;
    height: 100%;
  }

  .all-input {
    width: 80%;
    margin-bottom: 1rem;
  }
  .all-select {
    width: 80%;
    margin-bottom: 1rem;
  }
  .all-date {
    margin-bottom: 1rem;
  }
  .upload-demo{
    margin-bottom: 1rem;
  }
}
</style>
